<div class="space-y-5 animate-fade-in-up font-sans">

  <!-- Header con filtros -->
  <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col lg:flex-row gap-3 items-center justify-between relative overflow-hidden">
    <div class="absolute left-0 top-0 bottom-0 w-1.5 bg-[#1e3a8a]"></div>
    <div class="flex items-center gap-3 pl-2">
      <div class="bg-blue-50 p-2 rounded-xl text-[#1e3a8a]">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>
      </div>
      <div>
        <h2 class="text-base font-bold text-slate-900 tracking-tight">Panel de Control Operativo</h2>
        <p class="text-[10px] text-slate-400 mt-0.5">
          {{ esGerente ? 'Vista gerencial — todos los proyectos' : 'Vista coordinador — mis proyectos' }}
        </p>
      </div>
    </div>
    <div class="flex flex-wrap gap-2">
      <select [value]="filtroDivision()" (change)="filtroDivision.set($any($event.target).value)"
              class="border border-slate-200 bg-slate-50 text-slate-700 py-1.5 px-3 rounded-lg text-xs font-semibold outline-none focus:ring-2 focus:ring-[#1e3a8a]/20">
        <option value="todas">Todas las divisiones</option>
        <option value="civiles">Construcción</option>
        <option value="energia">Energía</option>
        <option value="telecomunicaciones">O&M</option>
      </select>
      <select [value]="filtroEstado()" (change)="filtroEstado.set($any($event.target).value)"
              class="border border-slate-200 bg-slate-50 text-slate-700 py-1.5 px-3 rounded-lg text-xs font-semibold outline-none focus:ring-2 focus:ring-[#1e3a8a]/20">
        <option value="todos">Todos los estados</option>
        <option value="PENDIENTE">Pendiente</option>
        <option value="PENDIENTE_PRELIMINARES">Preliminares</option>
        <option value="EN_EJECUCIÓN">En Ejecución</option>
        <option value="FINALIZADO_PARCIAL">Fin. Parcial</option>
        <option value="FINALIZADO_TOTAL">Finalizado</option>
        <option value="Cancelado">Cancelado</option>
      </select>
    </div>
  </div>

  @if (cargando()) {
    <div class="flex items-center justify-center h-40 text-slate-400">
      <svg class="animate-spin w-6 h-6 mr-3" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
      Cargando datos...
    </div>
  } @else {

  <!-- KPIs -->
  <div class="grid grid-cols-2 lg:grid-cols-5 gap-3">
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col">
      <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Proyectos activos</p>
      <h3 class="text-3xl font-black text-slate-900">{{ kpiActivos() }}</h3>
      <p class="text-[10px] text-slate-400 mt-1">de {{ proyectosFiltrados().length }} totales</p>
    </div>
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col">
      <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Presupuestado</p>
      <h3 class="text-xl font-black text-slate-900">{{ kpiPresupuestado() | currency:'COP':'symbol-narrow':'1.0-0' }}</h3>
      <p class="text-[10px] text-slate-400 mt-1">valor total OC</p>
    </div>
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col">
      <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Facturado</p>
      <h3 class="text-xl font-black text-emerald-600">{{ kpiFacturado() | currency:'COP':'symbol-narrow':'1.0-0' }}</h3>
      <p class="text-[10px] text-slate-400 mt-1">ingresos reconocidos</p>
    </div>
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col">
      <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Gasto Real</p>
      <h3 class="text-xl font-black text-amber-600">{{ kpiGasto() | currency:'COP':'symbol-narrow':'1.0-0' }}</h3>
      <p class="text-[10px] text-slate-400 mt-1">costos ejecutados</p>
    </div>
    <div class="bg-[#1e3a8a] p-4 rounded-2xl shadow-md flex flex-col">
      <p class="text-[10px] font-bold text-blue-200 uppercase tracking-widest mb-1">Utilidad</p>
      <h3 class="text-xl font-black text-white">{{ kpiUtilidad() | currency:'COP':'symbol-narrow':'1.0-0' }}</h3>
      <p class="text-[10px] text-blue-300 mt-1">margen {{ kpiMargen() }}%</p>
    </div>
  </div>

  <!-- Gráficas -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">

    <!-- Estado del portafolio -->
    <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 flex flex-col" style="height:300px">
      <h3 class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3">Estado del portafolio</h3>
      <div class="flex-1 relative min-h-0">
        <canvas baseChart
          [data]="estadosChartData()"
          [options]="estadosOptions"
          [type]="'doughnut'">
        </canvas>
      </div>
    </div>

    <!-- Por división -->
    <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 flex flex-col" style="height:300px">
      <h3 class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3">Proyectos por división</h3>
      <div class="flex-1 relative min-h-0">
        <canvas baseChart
          [data]="divisionChartData()"
          [options]="divisionOptions"
          [type]="'bar'">
        </canvas>
      </div>
    </div>

    <!-- Facturado vs Presupuestado -->
    <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 flex flex-col" style="height:300px">
      <h3 class="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3">Top proyectos — presupuesto vs ejecución</h3>
      <div class="flex-1 relative min-h-0">
        <canvas baseChart
          [data]="facturacionChartData()"
          [options]="facturacionOptions"
          [type]="'bar'">
        </canvas>
      </div>
    </div>

  </div>

  <!-- Tabla de proyectos -->
  <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
    <div class="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
      <div>
        <h3 class="text-sm font-bold text-slate-800">Desglose de Proyectos</h3>
        <p class="text-[10px] text-slate-400 mt-0.5">{{ tablaProyectos().length }} registros</p>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-[10px] text-slate-400">Clientes activos:</span>
        <span class="font-bold text-[#1e3a8a] text-sm">{{ cantidadClientes() }}</span>
      </div>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full text-left whitespace-nowrap">
        <thead class="bg-slate-50 text-slate-500 text-[10px] uppercase font-bold tracking-widest border-b border-slate-100">
          <tr>
            <th class="px-4 py-3">Código</th>
            <th class="px-4 py-3">Proyecto</th>
            <th class="px-4 py-3">División</th>
            <th class="px-4 py-3">Cliente</th>
            <th class="px-4 py-3 text-center">Estado</th>
            <th class="px-4 py-3 text-right">Presupuestado</th>
            <th class="px-4 py-3 text-right">Facturado</th>
            <th class="px-4 py-3 text-right">Gasto</th>
            <th class="px-4 py-3 text-right">Margen</th>
            <th class="px-4 py-3">Responsable</th>
          </tr>
        </thead>
        <tbody class="text-sm text-slate-700 divide-y divide-slate-50">
          @for (p of tablaProyectos(); track p.id) {
            <tr class="hover:bg-blue-50/30 transition-colors">
              <td class="px-4 py-3 font-bold text-[#1e3a8a] text-xs">{{ p.codigo }}</td>
              <td class="px-4 py-3 font-semibold text-slate-900 max-w-[200px] truncate">{{ p.nombre }}</td>
              <td class="px-4 py-3 text-xs text-slate-500">{{ divisionLabel(p.lineaNegocio) }}</td>
              <td class="px-4 py-3 text-xs text-slate-500 max-w-[140px] truncate">{{ p.cliente?.razonSocial || '—' }}</td>
              <td class="px-4 py-3 text-center">
                <span class="px-2 py-0.5 rounded text-[9px] font-black uppercase tracking-wide"
                      [ngClass]="estadoClass(p.estado)">
                  {{ p.estado.replace('_', ' ') }}
                </span>
              </td>
              <td class="px-4 py-3 text-right text-xs font-bold text-slate-700">
                {{ p.valorOC | currency:'COP':'symbol-narrow':'1.0-0' }}
              </td>
              <td class="px-4 py-3 text-right text-xs font-bold text-emerald-600">
                {{ p.valorFacturado | currency:'COP':'symbol-narrow':'1.0-0' }}
              </td>
              <td class="px-4 py-3 text-right text-xs font-bold text-amber-600">
                {{ p.valorGasto | currency:'COP':'symbol-narrow':'1.0-0' }}
              </td>
              <td class="px-4 py-3 text-right text-xs font-bold"
                  [ngClass]="(p.utilidad || 0) >= 0 ? 'text-emerald-600' : 'text-red-500'">
                {{ p.valorOC > 0 ? (((p.valorFacturado - p.valorGasto) / p.valorOC) * 100).toFixed(0) + '%' : '—' }}
              </td>
              <td class="px-4 py-3 text-xs text-slate-500">{{ p.responsable?.nombre || '—' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="10" class="px-5 py-10 text-center text-slate-400 text-xs">
                No hay proyectos para mostrar con los filtros actuales.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  } <!-- end @if cargando -->

</div>
